import type { ResourcesConfig } from 'aws-amplify';

const myDomain = window?.location?.hostname;
const myProtocol = window?.location?.protocol;
const mySignInUrl = myDomain?.includes('.vercel') && myProtocol ? `${myProtocol}//${myDomain}/auth/callback` : undefined;
const mySignOutUrl = myDomain?.includes('.vercel') && myProtocol ? `${myProtocol}//${myDomain}` : undefined;

export const awsConfig: ResourcesConfig = {
   Auth: {
      Cognito: {
         userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
         userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
         loginWith: {
            oauth: {
               domain: import.meta.env.VITE_COGNITO_DOMAIN,
               scopes: ['email', 'openid', 'phone'],
               responseType: 'code',
               redirectSignIn: [
                  'https://apollo11.apaluma.com/auth/callback',
                  'https://apollo.apaluma.com/auth/callback',
                  'https://platform.apaluma.com/auth/callback',
                  'https://nmed.apaluma.com/auth/callback',
                  mySignInUrl,
                  import.meta.env.VITE_REDIRECT_SIGN_IN,
               ].filter(Boolean) as string[],
               redirectSignOut: [
                  'https://apollo11.apaluma.com',
                  'https://apollo.apaluma.com',
                  'https://platform.apaluma.com',
                  mySignOutUrl,
                  import.meta.env.VITE_REDIRECT_SIGN_OUT,
               ].filter(Boolean) as string[],
               providers: ['Google'],
            },
         },
      },
   },
};
